import '.aj{flex-shrink:0;}.ssr-plugin'
import '.ac{padding:1rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.am{height:100%;}.ssr-plugin'
import '.b8{border:none;}.ssr-plugin'
import '.db{background-color:transparent;}.ssr-plugin'
import '.dc{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a2{align-items:stretch;}.ssr-plugin'
import '.ct{position:sticky;}.ssr-plugin'
import '.dd{top:4rem;}.ssr-plugin'
import '.de{z-index:7;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.df{padding-bottom:1rem;}.ssr-plugin'
import '.d3{margin-bottom:1rem;}.ssr-plugin'
import '.dg{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.ce{top:0px;}.ssr-plugin'
import '.cf{left:0px;}.ssr-plugin'
import '.cg{right:0px;}.ssr-plugin'
import '.ch{bottom:0px;}.ssr-plugin'
import '.dh{z-index:9999;}.ssr-plugin'
import '.di{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.cs{justify-content:flex-end;}.ssr-plugin'
import '.an{flex:1;}.ssr-plugin'
import '.cq{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="aj ac n am b8 db dc"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e a2"
    >
      <div className="ct dd de t df d3 dg d"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="i ce cf cg ch dh t di d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="ac d cs dg"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="an cq">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
